<!-- <ngx-loading-bar color="#43c3f1" height="3px" diameter="30px"></ngx-loading-bar>   -->
<app-loading-spinner></app-loading-spinner>
<router-outlet></router-outlet>